export enum DataMode {
  Create = 'Create',
  Update = 'Update',
  View = 'View'
}
